export class Producttype {
	id: number;
	is_wine: boolean;
	sort_order: number;
	
    name_nl: string;
	
    name_en: string;
	
    name_fr: string;
	
    name_de: string;
	
	created_at: string;
    updated_at: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/producttype.ts